var map = {
	"./angle-down.svg": 94507,
	"./anna-profile-pic.svg": 79884,
	"./arrow-down.svg": 87190,
	"./arrow-restart.svg": 78619,
	"./arrow-up.svg": 15906,
	"./bell.svg": 84437,
	"./bigCheckmark.svg": 21730,
	"./check-circle.svg": 5490,
	"./check.svg": 45809,
	"./chevron-next.svg": 18165,
	"./chevrone-down.svg": 93649,
	"./chevrone-reco.svg": 92159,
	"./circle-cross.svg": 2913,
	"./consultation.svg": 59407,
	"./credit-card-payment-method.svg": 96545,
	"./cross.svg": 45747,
	"./curved_arrow.svg": 50624,
	"./data-protection.png": 46580,
	"./de.svg": 66598,
	"./default-avatar.svg": 50662,
	"./docs.svg": 98878,
	"./document_img.png": 44814,
	"./documents.png": 86292,
	"./download-icon-with-dot.svg": 58117,
	"./empty-profile.png": 94067,
	"./en.svg": 99138,
	"./error.svg": 71043,
	"./exclamation-mark-with-circle.svg": 71433,
	"./external-link.svg": 8342,
	"./eye.svg": 61675,
	"./facebook.svg": 17430,
	"./flag-circle.png": 81072,
	"./flower.jpg": 47172,
	"./google-authenticator-android@1x.jpg": 63242,
	"./google-authenticator-android@2x.jpg": 94493,
	"./google-authenticator-android@3x.jpg": 99991,
	"./google-authenticator-apple@1x.jpg": 26585,
	"./google-authenticator-apple@2x.jpg": 10679,
	"./google-authenticator-apple@3x.jpg": 90141,
	"./icon-arrow-down.svg": 222,
	"./icon-arrow-left.svg": 74920,
	"./icon-arrow-right.svg": 59542,
	"./icon-assistant-cta-page-1.svg": 10197,
	"./icon-assistant-cta-page-2.svg": 67549,
	"./icon-assistant-cta-page-3.svg": 36192,
	"./icon-assistant.svg": 48922,
	"./icon-beneficiaries.svg": 98399,
	"./icon-birthday-cake.svg": 50928,
	"./icon-bold-chevron-up.svg": 35372,
	"./icon-calendar.svg": 5144,
	"./icon-check-square.svg": 1752,
	"./icon-check-unfilled-circle.svg": 96682,
	"./icon-check-with-dot.svg": 41726,
	"./icon-company.svg": 68055,
	"./icon-contact.svg": 96715,
	"./icon-dashboard.svg": 47660,
	"./icon-delete.svg": 61086,
	"./icon-documents.svg": 14261,
	"./icon-dot.svg": 24695,
	"./icon-download.svg": 62122,
	"./icon-edit.svg": 44702,
	"./icon-error.svg": 96105,
	"./icon-file.svg": 39178,
	"./icon-filled-check.svg": 34942,
	"./icon-gear.svg": 50918,
	"./icon-hide-eye.svg": 63562,
	"./icon-info-white.svg": 59134,
	"./icon-info.svg": 98245,
	"./icon-menu.svg": 15716,
	"./icon-my-agent.svg": 54255,
	"./icon-outside-link.svg": 75397,
	"./icon-people.svg": 35623,
	"./icon-person-revoke.svg": 85955,
	"./icon-plus.svg": 76371,
	"./icon-pricing-check.svg": 63165,
	"./icon-profile.svg": 80205,
	"./icon-question-with-circle.svg": 35189,
	"./icon-reminder.svg": 73369,
	"./icon-round-check.svg": 7074,
	"./icon-safety-box.svg": 77648,
	"./icon-search.svg": 26543,
	"./icon-shared-file.svg": 99408,
	"./icon-shield.svg": 12708,
	"./icon-show-eye-small.svg": 44800,
	"./icon-show-eye.svg": 34486,
	"./icon-sign-out.svg": 18842,
	"./icon-upgrade-profile-benefits-1.svg": 24756,
	"./icon-upgrade-profile-benefits-2.svg": 10801,
	"./icon-upgrade-profile-benefits-3.svg": 56006,
	"./icon-vault.svg": 64722,
	"./icon-warning.svg": 64043,
	"./icon_assets_empty.svg": 34103,
	"./icon_auth_footer_de_dots.svg": 10386,
	"./icon_auth_footer_doc.svg": 51160,
	"./icon_bene_process_1.svg": 66121,
	"./icon_bene_process_2.svg": 67695,
	"./icon_bene_process_3.svg": 25013,
	"./icon_bug.svg": 67933,
	"./icon_bulb.svg": 61833,
	"./icon_check.svg": 97915,
	"./icon_contact_warning.svg": 79851,
	"./icon_copy.svg": 50627,
	"./icon_empty.svg": 12377,
	"./icon_empty_contacts.svg": 4459,
	"./icon_filled_profile.svg": 99624,
	"./icon_filled_shield.svg": 23961,
	"./icon_legal_document.svg": 66409,
	"./icon_login.svg": 49628,
	"./icon_notification_bell.svg": 56121,
	"./icon_person.svg": 84538,
	"./icon_shield.svg": 86615,
	"./illustration-intro-page-1.png": 70111,
	"./illustration-intro-page-2.png": 67850,
	"./illustration-intro-page-3.png": 97247,
	"./img-add-family-member.png": 71884,
	"./img-auth-benefit-1.png": 47646,
	"./img-auth-benefit-2.png": 97002,
	"./img-auth-benefit-3.png": 13203,
	"./img-auth-rectangle.png": 31837,
	"./img-bene-supportive-1.png": 24685,
	"./img-bene-supportive-2.png": 66161,
	"./img-bene-supportive-3.png": 2079,
	"./img-completed-document.png": 84114,
	"./img-deletion-warning.png": 90711,
	"./img-empty-documents.png": 54314,
	"./img-family-account.png": 45564,
	"./img-headstone.png": 67513,
	"./img-key-holder-info-1.png": 69305,
	"./img-key-holder-info-2.png": 16180,
	"./img-key-holder-info-3.png": 42840,
	"./img-key-holder-page-error.png": 4680,
	"./img-key-holder-page-success.png": 59895,
	"./img-plant-contact.png": 96010,
	"./img-referral.png": 37106,
	"./img-requirement-check.png": 90635,
	"./img_all_done.png": 6336,
	"./img_bg_rectangle_1.svg": 71425,
	"./img_bg_rectangle_2.svg": 12739,
	"./img_german_law_validation.png": 14250,
	"./img_inheritance_tax.png": 23183,
	"./img_no_result.png": 68833,
	"./img_no_result_2.png": 77410,
	"./img_successful_payment.png": 97171,
	"./img_successful_verification.png": 76615,
	"./img_unsuccessful_verification.png": 2796,
	"./instagram.svg": 94048,
	"./insurance.svg": 76909,
	"./leaf.svg": 10490,
	"./linkedin.svg": 2199,
	"./loading-spinner.svg": 65422,
	"./location-icon.svg": 32023,
	"./lock-icon.svg": 78341,
	"./logo.svg": 91937,
	"./logo_bundesnotarkammer.svg": 86852,
	"./logo_ninebarc.svg": 79435,
	"./mail-icon.svg": 71002,
	"./phone-icon.svg": 61802,
	"./plant.svg": 89593,
	"./plant2.svg": 72470,
	"./radio-checked.svg": 14754,
	"./radio-unchecked.svg": 47034,
	"./refer-a-friend.svg": 23857,
	"./referral_card_image.png": 68762,
	"./sandwich.svg": 87927,
	"./self_key_holder_after_death_step_1.png": 3251,
	"./self_key_holder_after_death_step_2.png": 81013,
	"./self_key_holder_after_death_step_3.png": 98987,
	"./sepa-payment-method.svg": 62404,
	"./server-security.png": 62900,
	"./sign_document.svg": 7664,
	"./single_leaf.png": 11967,
	"./steps-section-leaves.png": 62216,
	"./success.svg": 40032,
	"./successful-postal-payment.png": 46847,
	"./switch-account-1.svg": 19016,
	"./switch-account-2.svg": 75713,
	"./task-achievement.png": 83601,
	"./tick.svg": 4319,
	"./trash-hollow.svg": 61923,
	"./two-column-page-bg-1.png": 90097,
	"./upload.svg": 10237,
	"./v-shaped-down.svg": 78870,
	"./v-shaped-up.svg": 73258,
	"./warning.svg": 81755,
	"./zero-knowledge-policy.png": 32949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89230;